import { CartItemModel } from "@/redux/modules/api/data/cart/@types/cart.model";
import * as AddToCartTracker from "@/services/tracking/trackers/feature/addToCart.tracker";
import * as RemoveFromCartTracker from "@/services/tracking/trackers/feature/removeFromCart.tracker";

export const trackCartItem = (
    cartItem: CartItemModel,
    quantityDelta: number
) => {
    const isAddToCart = quantityDelta > 0;
    const quantity = Math.abs(quantityDelta);

    if (isAddToCart) {
        AddToCartTracker.trackCartItem(cartItem, quantity);
    } else {
        RemoveFromCartTracker.trackCartItem(cartItem, quantity);
    }
};
